import { autoinject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { Customer } from '../../models/customer';
import { State } from '../../services/global-state';
import { PayrazrService } from '../../services/payrazr';
import { I18N } from 'aurelia-i18n';

@autoinject
export class ChangePassword {
	model: any;
	validationErrors: any;

	constructor(
		private payrazr: PayrazrService, 
		private globalState: State, 
		private router: Router, 
		private i18n:I18N
		) {
		this.model = new Model();
		this.validationErrors = [];
	}

	activate() {
	}

	submit() {
		this.validationErrors = [];
		var validator = new Validator(this.i18n);

		if (validator.modelHasErrors(this.model)) {
			this.validationErrors = validator.errors;
		} else {
			this.doUpdate();
		}
	}

	doUpdate() {
		this.payrazr.updatePassword(this.model.oldPassword, this.model.newPassword)
			.then(result => {
				if (result.errors) {
					throw result.errors;
				} else {
					return this.payrazr.login(this.globalState.customer.securitySettings.username, this.model.newPassword);
				}
			})
			.then(response => {
				this.globalState.customer = new Customer(this.globalState.business, response.entity.customer);
				this.redirectAfterChangePassword();
			})
			.catch(error => {
				if (error.constructor === Array) {
					this.validationErrors.push(error);
				} else if (error.constructor === Response) {
					return error.json()
						.then(r => {
							this.validationErrors = this.filterErrorResponse(r.Message);
						});
				} else {
					this.validationErrors.push(error);
				}
			});
	}

	filterErrorResponse(messageFromResponseBody) {
		if (messageFromResponseBody.indexOf('User not found') !== -1) {
			return ['Change password failed: Incorrect current password'];
		}
		return [messageFromResponseBody];
	}

	redirectAfterChangePassword() : void {
		this.router.navigateToRoute('secure');
	}
}

class Model {
	oldPassword: any = "";
	newPassword: any = "";
	confirmPassword: any = "";

	constructor() {
	}
}

class Validator {
	errors: any;
	i18n: any;
	constructor(i18next:any) {
		this.errors = [];
		this.i18n = i18next;
	}

	modelHasErrors(model) {
		if (model.oldPassword.length === 0) {
			this.addError(this.i18n.t('pleaseEnterOldPassword', 'Please enter your old password'));
		}
		if (model.newPassword.length === 0) {
			this.addError(this.i18n.t('pleaseEnterNewPassword', 'Please enter a new password'));
		}
		if (model.confirmPassword.length === 0) {
			this.addError(this.i18n.t('reEnterNewPassword', 'Please re-enter your new password'));
		} else if (model.confirmPassword !== model.newPassword) {
			this.addError(this.i18n.t('passwordsDoNotMatch', 'Passwords do not match'));
		}

		return this.errors.length > 0;
	}

	addError(e) {
		this.errors.push(e);
	}
}
